import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';

export default makeStyles(
  ({ spacing }) => ({
    root: {
      color: TextColors.light,
      width: '100%',
      rowGap: spacing(5),
      display: 'flex',
      flexDirection: 'column',
    },
    options: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: spacing(2),
      rowGap: spacing(2),
    },
    marketo: {
      height: '0 !important',
      width: '0 !important',
      overflow: 'hidden',
    },
    link: {
      width: 'fit-content',
    },
    preloaderContainer: {
      position: 'relative',
      minHeight: '64px',
      minWidth: '64px',
      width: '100%',

      '&.has-text': {
        marginTop: spacing(2),
      },
    },
    preloader: {
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      alignItems: 'center',
      position: 'absolute',
      top: 0,
      left: 0,
      height: '100%',
      color: TextColors.light,
    },
  }),
  { name: 'GenToggleMenu' },
);
